<template>
  <vs-card class="content_mb_0 mb-0">
    <div class="flex flex-wrap">
      <div class="flex flex-wrap lg:w-5/12 md:w-1/3 w-full p-2">
        <div class="user_profile_img_holder">
          <img :src="clientDetails.basic_details.picture" alt="dp" />
        </div>
        <div style="width: calc(100% - 115px);" class="pl-4">
          <div class="flex flex-wrap toggle_switch_holder">
            <div class="inline-flex">
              <p>
                {{ clientDetails.basic_details.first_name }}
                {{ clientDetails.basic_details.last_name }}
              </p>
              <toggle-button
                  :value="clientDetails.basic_details.active_user == '1'"
                  :sync="true"
                  :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
                  class="mr-1"
                  @change ="handleToggle()"
              />
            </div>
            <p class="w-full">{{ clientDetails.basic_details.email }}</p>
          </div>
          <div class="flex mt-4">
            <vs-tooltip text="Edit" color="primary">
              <vs-button
                type="border"
                icon="edit"
                color="primary"
                class="mr-2"
                v-if="checkEditPermission"
                @click="showEdit"
              />
            </vs-tooltip>
            <vs-tooltip text="Delete" color="primary">
              <vs-button
                type="border"
                icon="delete"
                @click="openConfirm"
                color="danger"
              />
            </vs-tooltip>
          </div>
        </div>
      </div>
      <div class="lg:w-7/12 md:w-2/3 w-full p-2">
        <div class="profile_row_details flex flex-wrap">
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <span class="material-icons-outlined">person</span>
            <label>Username</label>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">{{ clientDetails.basic_details.email }}</p>
            <vs-input
              v-else
              class="w-full"
              disabled
              v-model="clientDetails.basic_details.email"
            ></vs-input>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <span class="material-icons-outlined">grade</span>
            <label>Role</label>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">{{ clientDetails.basic_details.user_type }}</p>
            <vs-input
              v-else
              class="w-full"
              disabled
              v-model="clientDetails.basic_details.user_type"
            ></vs-input>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <span class="material-icons-outlined">call</span>
            <label>Phone Number</label>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">{{ clientDetails.basic_details.mobile }}</p>
            <vs-input
              v-else
              class="w-full"
              v-model="clientDetails.basic_details.mobile"
            ></vs-input>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <span class="material-icons-outlined">email</span>
            <label>Email</label>
          </div>
          <div class="lg:w-1/4 md:w-1/2 w-full flex items-center p-1">
            <p style="word-break: break-all;" class="one_line_truncate" v-if="!editData">{{ clientDetails.basic_details.email }}</p>
            <vs-input
              v-else
              class="w-full"
              disabled
              v-model="clientDetails.basic_details.email"
            ></vs-input>
          </div>
          <!-- <vs-col vs-lg="3" vs-xs="6" class="flex items-center p-1">
                        <span class="material-icons-outlined">lock</span>
                        <label>Password</label>
                    </vs-col>
                    <vs-col vs-lg="3" vs-xs="6" class="p-1">
                        <p>njanjanj</p>
                    </vs-col> -->
          <div class="w-full text-right p-1" v-if="editData">
            <span
              style="font-size: 24px; color: green"
              class="material-icons-outlined cursor-pointer mr-0"
              @click="UpdateDetails"
              >done</span
            >
            <span
              style="font-size: 24px; color: red"
              class="material-icons-outlined cursor-pointer mr-0"
              @click="editData = false"
              >clear</span
            >
          </div>
        </div>
      </div>
    </div>
  </vs-card>
</template>
<script>
import { ToggleButton } from "vue-js-toggle-button";
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { updateClient, deleteClient, Clienttoogle } from '@/api/client'
import { getActivityList } from '@/api/activityLog'

export default {
  mixins: [PermissionMiddleware],
  props: {
    clientDetails: {
      default: null
    }
  },
  components: {
    ToggleButton
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Students')
    }
  },
  mounted () {
    if (this.$route.query) {
      if (this.$route.query.mode === 'edit') {
        this.editData = true
      }
    }
  },
  data () {
    return {
      editData: false
    }
  },
  methods: {
    showEdit () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editData = true
    },
    openConfirm () {
      if (!this.checkDeletePermission) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you don\'t have permission to perform this action',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false;
      }
      if (this.clientDetails.basic_details.active_user == '1') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can\'t delete active student',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure to delete the student?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.client_Delete()
    },
    async client_Delete () {
      try {
        const deleting_id = this.$route.params.client_id
        const payload = {
          client_user_id: [deleting_id]
        }
        await deleteClient(payload, this.$store.getters.customerId)

        this.$vs.notify({
          color: 'success',
          title: 'Deleted Client',
          text: 'The Client deleted successfully'
        })
        this.$router.push({ name: 'students' })
      } catch (e) {
        console.log(e)
      }
    },
    async UpdateDetails () {
      try {
        const reqpayload = {
          updateField: {
            first_name: this.clientDetails.basic_details.first_name,
            middle_name: this.clientDetails.basic_details.middle_name,
            last_name: this.clientDetails.basic_details.last_name,
            email: this.clientDetails.basic_details.email,
            mobile: this.clientDetails.basic_details.mobile,
            address: this.clientDetails.basic_details.address,
            bio: this.clientDetails.bio,
            social_media: this.clientDetails.social_media
          }
        }
        const object1 = {
          dynamic_fields: {}
        }

        object1.dynamic_fields = this.dynamicform
        const payload = Object.assign({}, reqpayload, object1)

        const customer_id = localStorage.getItem('customer_id')

        const { data } = await updateClient(
          this.$route.params.client_id,
          payload,
          customer_id
        )
        this.clientDetails = data.data.clientUser

        this.getLastActivity()

        this.editData = false
        this.$vs.notify({
          title: 'Updated',
          text: 'Student updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
       
        console.log(e.data.data.clientUser.basic_details.mobile)
        this.clientDetails.basic_details.mobile = e.data.data.clientUser.basic_details.mobile
        this.editData = false
        console.log(this.clientDetails.basic_details)
       
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        
        //this.clientDetails = e.data.clientUser

        //54534534
      }
    },
    async handleToggle () {
      
      try {
        const togglePayload = {
          active_user: this.clientDetails.basic_details.active_user === '1' ? 0 : 1,
          client_user_id: this.$route.params.client_id
        }
        
        await Clienttoogle(togglePayload)
        
        const msg = togglePayload.active_user ? 'Student activated successfully' : 'Student deactivated successfully'
        this.clientDetails.basic_details.active_user = togglePayload.active_user ? "1" : "0"
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e.data.message,
          ...this.warnProp()
        })
      }
    },
    async getLastActivity () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.$route.params.client_id,
        platform_module_id: 4
      }

      try {
        const response = await getActivityList(payload)
        this.new_activity = response.data.data.activity[0]
        this.$emit('studentUpdated', this.new_activity)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>